// extracted by mini-css-extract-plugin
export var divider = "_4e-0";
export var dividerText = "_4e-1";